//内容分类词典
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  Row,
  Table,
  Typography,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import React, { useState } from "react";
import {
  deleteCategories,
  postCategories,
  putCategories,
} from "../../../api/api";
// import { changeadministratior } from '../../../../api/api';
// import './index.css'
const SecondDictionary = (props) => {
  // console.log('props',props);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNew, setIsNew] = useState(false); //判断是新增还是修改

  //为每个元素添加他们的一级菜单名字
  let initData = props.firstCategory.SubCategories
    ? props.firstCategory.SubCategories.map((item) => {
        return Object.assign(item, { firstName: props.firstCategory.Name });
      })
    : [];
  // console.log(initData);
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `请输入 ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const [form] = Form.useForm();
  const [data, setData] = useState(initData);
  const [count, setCount] = useState(() => {
    return props.count;
  });
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.ID === editingKey;

  //按编辑后的调用
  const edit = (record) => {
    form.setFieldsValue({
      ID: "",
      Name: "",
      ...record,
    });

    console.log("编辑", record);
    setEditingKey(record.ID);
    setIsNew(false);
  };
  //点击取消时的回调
  const cancel = (k) => {
    // console.log(editingKey);
    setEditingKey("");
    if (isNew) {
      //如果是新增就进行删除新增行的操作，如果不是新增就是删除，那么就不进行改操作
      const newData = data.filter((item) => item.ID !== editingKey);
      setData(newData);
    }
  };

  //按保存时的调用
  const save = async () => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => editingKey === item.ID);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        setEditingKey("");
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
      const postParam = {
        //定义新增数据参数
        superior_id: props.firstCategory.ID,
        name: row.Name,
        type: Number(localStorage.getItem("contentType")),
      };
      const putParam = {
        //定义新增数据参数
        superior_id: props.firstCategory.ID,
        name: row.Name,
        id: editingKey,
        type: Number(localStorage.getItem("contentType")),
      };
      isNew
        ? //上传新增数据
          postCategories(postParam).then((res) => {
            message.success("内容分类新增成功！");
          })
        : //上传修改数据
          putCategories(putParam).then((res) => {
            message.success("内容分类修改成功！");
          });
      props.setIsFresh((pre) => !pre);
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  //删除操作的调用
  const handleDelete = (key) => {
    // console.log(key)
    // const newData = data.filter((item) => item.ID !== key)
    // setData(newData)
    // setCount(count - 1)
    deleteCategories(key).then((res) => {
      const code = res.data.code;
      // console.log(code)
      if (code === 1008) {
        message.error("存在内容，不能删除！");
      } else if (code === 0) {
        //返回null的时候表示正常删除
        message.success("内容分类删除成功！");
        const newData = data.filter((item) => item.ID !== key);
        setData(newData);
        setCount(count - 1);
        props.setIsFresh((pre) => !pre);
      }
    });
  };

  //新增行的调用
  const handleAdd = () => {
    const newData = {
      ID: count,
      Name: "",
      firstName: props.firstCategory.Name,
    };
    setData([...data, newData]);
    //让新增的行为可编辑状态
    setEditingKey(count);
    setCount(count + 1);
    setIsNew(true);
  };

  const columns = [
    {
      title: "序号",
      dataIndex: "ID",

      // editable: true,
    },
    {
      title: "二级分类名称",
      dataIndex: "Name",
      editable: true,
    },
    {
      title: "所属一级分类",
      dataIndex: "firstName",
    },
    {
      title: "操作",
      width: "15%",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        // console.log('二级分类时的单行数据：',record);
        return editable ? (
          <Row>
            <Col span={12}>
              {" "}
              <Typography.Link
                onClick={() => save(record.key)}
                style={{
                  marginRight: 8,
                }}
              >
                保存
              </Typography.Link>
            </Col>
            <Col span={12}>
              <Popconfirm title="确认取消编辑?" onConfirm={cancel}>
                <a>取消</a>
              </Popconfirm>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col span={12}>
              {" "}
              <Typography.Link
                disabled={editingKey !== ""}
                onClick={() => edit(record)}
              >
                编辑
              </Typography.Link>
            </Col>
            <Col span={12}>
              <Popconfirm
                title="确认删除?"
                onConfirm={() => handleDelete(record.ID)}
              >
                <a>删除</a>
              </Popconfirm>
            </Col>
          </Row>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "age" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const showModal = () => {
    setIsModalOpen(true);
  };

  // const handleOk = () => {
  //       setIsModalOpen(false)
  // };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };
  return (
    <>
      <a onClick={showModal}>查看</a>
      <Modal
        title="内容分类字典"
        open={isModalOpen}
        // onOk={handleOk}
        onCancel={handleCancel}
        footer={
          [] // 设置footer为空，去掉 取消 确定默认按钮
        }
        width={"800px"}
      >
        <Form form={form} component={false}>
          <Table
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            bordered
            dataSource={data}
            columns={mergedColumns}
            rowClassName="editable-row"
            pagination={false}
          />
          <Button
            type="dashed"
            onClick={handleAdd}
            block
            icon={<PlusOutlined />}
            style={{ marginTop: "30px" }}
          >
            新增二级分类
          </Button>
        </Form>
      </Modal>
    </>
  );
};

export default SecondDictionary;
